module.exports = __webpack_public_path__ + "static/media/bulk.cc57bb83.svg";